import React, { useState, useEffect, useContext } from 'react';
import { Menu, Icon, Sidebar, Container, Image } from 'semantic-ui-react'
import LogoTeamLigaGenerator from '../../../assets/tglogov5_small.png';
import LogoTeamLigaGeneratorl from '../../../assets/tglogov6_small.png';

import { useHistory } from "react-router-dom";
import useAuth from '../../../hooks/useAuth';
import AuthContext from '../../../context/authContext';
import { useToasts } from 'react-toast-notifications';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import RouterPage from '../../../layout/ui/RouterPage';

import ModalInfo from '../Modal/ModalInfo';
import Login from '../Modal/Login';
import Registration from '../Modal/Registration';
import { LiveIcon3, showLoadingRootPage } from '../../../myfunctions';
import LanguageSelect from '../../../languageSelect';
import { useTranslation } from "react-i18next";
import { useCookies } from 'react-cookie';
import MyImageLazy from '../../../tools/MyImageLazy';
import ScrollToTop from '../../../ScrollToTop';



function MenuPage() {
  const { addToast } = useToasts();
  let history = useHistory();
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
  const authContext = useContext(AuthContext);
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false)
  const [cookies, setCookie] = useCookies(['DMTheme']);

  const [mode, setMode] = useState(authContext.darkMode ? 'dark' : 'light')
  const [showDM, setshowDM] = useState(false)


  function clickLink(link) {
    //addLinkToSitemap(link)
    history.push(link)

  }

  useEffect(() => {
    checkDM()
    return () => { }; // use effect cleanup to set flag false, if unmounted
  },)// eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
      console.log("View: MenuPage")
    }

    if (cookies.DMTheme) {
      if (cookies.DMTheme.DarkMode) {
        checkAndSetModeTheme('dark')
      } else {
        checkAndSetModeTheme('light')
      }
    } else {
      checkAndSetModeTheme('light')
    }
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps


  function checkAndSetModeTheme(co) {
    try {
      let wlh = window.location.href;
      if (wlh.indexOf('/light') > -1) {
        setMode('light')
        authContext.changeDarkMode(false)
      } else if (wlh.indexOf('/dark') > -1) {
        setMode('dark')
        authContext.changeDarkMode(true)
      } else if (co === 'dark') {
        setMode('dark')
        authContext.changeDarkMode(true)
      } else {
        setMode('light')
        authContext.changeDarkMode(false)
      }

    } catch (err) {
      console.log(err)
      setMode('dark')
      authContext.changeDarkMode(true)
    }
  }




  function logoutApp() {
    addToast('Wylogowano z aplikacji', { appearance: 'success' })
    setVisible(false)
    setAuth(false)
  }

  function changegView(co) {
    authContext.changeView(co);
    history.push("/dashboard")
    setVisible(false)
    //window.sessionStorage.setItem('gView', JSON.stringify(co));
  }



  function returnStartPage() {
    window.localStorage.setItem('gView', JSON.stringify({}));
    authContext.changeView({ myView: "" })
    history.push("/")
  }



  function isViewTv() {
    try {
      let wlh = window.location.href;
      if (wlh.indexOf('/viewtv') > -1) {
        return true
      } else if (wlh.indexOf('/widget') > -1) {
        return true
      } else if (wlh.indexOf('/klub/') > -1) {
        return true
      } else if (wlh.indexOf('/turnieje/') > -1) {
        return true
      } else if (wlh.indexOf('/liga/') > -1) {
        return true
      } else if (wlh.indexOf('/match/panel/') > -1) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return false
    }

  }


  function iFrameTG() {
    try {
      let wlh = window.location.href;
      if (wlh.indexOf('/iftg') > -1) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return false
    }

  }

  function isDuel() {
    try {
      let wlh = window.location.href;
      if (wlh.indexOf('/duel/') > -1) {
        return true
      } else if (wlh.indexOf('/panel') > -1) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return false
    }

  }

  function checkDM() {
    let wlh = window.location.href;

    if (wlh.indexOf('/tg') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/tsv') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/viewtv/') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/cykl') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/turniej/') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/osiagniecia/') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/member/') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/duel/dart') > -1) {
      setshowDM(true)
    } else if (wlh.indexOf('/dashboard') > -1) {
      setshowDM(true)
    } else {
      setshowDM(false)
    }
  }

  function changeDarkMode2(mode) {
    let expiresdate = new Date();
    let today = new Date();
    expiresdate.setDate(today.getDate() + 365);

    if (mode === 'dark') {

      setCookie('DMTheme', { DarkMode: true }, { path: '/', expires: expiresdate });
      authContext.changeDarkMode(true)
    } else {

      setCookie('DMTheme', { DarkMode: false }, { path: '/', expires: expiresdate });
      authContext.changeDarkMode(false)
    }
    setMode(mode);
  }

  function isRootPage() {
    try {
      if (window.location.pathname === "/") {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  function logOutPanel() {
    authContext.changeTokenPanel(null)
    window.localStorage.removeItem('tokenPanel');
  }

  return (
    <>

      {iFrameTG() || isViewTv() ? isViewTv() ?
        <>
          <RouterPage />
          <ModalInfo />
        </>
        : <Sidebar.Pushable ><article className={authContext.darkMode ? "bgDartTheme" : "bgCenterPanel"} style={{ paddingBottom: 10 }} >
          {authContext.liveIcon === 1 ? LiveIcon3(t("LiveText")) : ''}
          <ModalInfo /><RouterPage />
          <Container textAlign='center' style={{ fontSize: 12, color: "grey", marginTop: 20, paddingTop: 10, marginBottom: 5 }}>
            <div style={{ fontSize: 12, color: authContext.darkMode ? "#fff" : "#414141", lineHeight: "12px" }}>Turniej-Generator.pl - generator drabinek turniejowych, tabel grupowych oraz lig.</div>
            <a href="https://turniej-generator.pl/" target="_blank" rel="noopener noreferrer" ><Image style={{ marginBottom: 20, marginTop: 5 }} size='small' centered src={authContext.darkMode ? LogoTeamLigaGenerator : LogoTeamLigaGeneratorl} name="TURNIEJ-GENERATOR.PL" alt="TURNIEJ-GENERATOR.PL" /></a>
          </Container>
        </article></Sidebar.Pushable> :
        <>
          <header id="root-id2">
            <Menu className='menuTG' style={{ zIndex: 10, overflowX: "clip" }} inverted>
              <Menu.Item onClick={() => returnStartPage()} style={{ width: 170, height: 40 }}><MyImageLazy height={30} src={LogoTeamLigaGenerator} name="Logo" alt="Logo" /></Menu.Item>

              {isDuel() ? showDM ? <Menu.Item style={{ width: 40 }}>
                {mode === "light" ? <Icon style={{ margin: "0 auto" }} className='cursorPointer' name="moon" title="DARK MODE" onClick={() => changeDarkMode2("dark")} /> : <Icon style={{ margin: "0 auto" }} className='cursorPointer' name="sun" title="LIGHT MODE" onClick={() => changeDarkMode2("light")} />}
              </Menu.Item> : "" :
                <Menu.Menu position='right' className='menuTG'>
                  {showDM ? <Menu.Item style={{ width: 40 }}>
                    {mode === "light" ? <Icon style={{ margin: "0 auto" }} className='cursorPointer' name="moon" title="DARK MODE" onClick={() => changeDarkMode2("dark")} /> : <Icon style={{ margin: "0 auto" }} className='cursorPointer' name="sun" title="LIGHT MODE" onClick={() => changeDarkMode2("light")} />}
                  </Menu.Item> : ""}
                  {!showDM && isRootPage() ?
                    <Menu.Item
                      icon="search"

                      style={{ width: 40 }}


                      onClick={() => authContext.changeModalInfo({ nameModal: "SearchTournamentTG", name: "Wyszukaj turniej", value: "" })}
                    /> : ""}
                  <Menu.Item><LanguageSelect /></Menu.Item>



                  {auth ?
                    <Menu.Item
                      icon="bars"
                      active={visible}
                      style={{ width: 40 }}
                      color="red"
                      className={visible ? 'blinkmpN2' : 'blinkmpN2bar'}
                      onClick={() => setVisible(visible ? false : true)}
                    />
                    : <Menu.Item
                      icon="user"
                      style={{ width: 40 }}
                      active={visible}
                      className={visible ? 'blinkmpN2' : 'blinkmpN2bar'}
                      color="red"
                      onClick={() => Number(process.env.REACT_APP_IN_CONSTRUCTION) === 0 ? history.push("/login") : authContext.changeModalInfo({ nameModal: "all", name: "Szanowni Państwo", value: "Generator Turniejów jest w trakcie tworzenie i uruchamiania aplikacji internetowej. Przepraszamy za niedogodności i zapraszamy wkrótce." })}
                    />}
                </Menu.Menu>
              }
              {authContext.tokenPanel && isDuel() ? <Menu.Menu position='right'>
                <Menu.Item
                  onClick={() => logOutPanel()}
                ><Icon name="sign-out" />WYLOGUJ</Menu.Item>
              </Menu.Menu>
                : ""}



            </Menu>
          </header>

          <ModalInfo />
          <Login />
          <Registration />


          <Sidebar.Pushable >

            <Sidebar

              as={Menu}
              animation='overlay'
              direction="top"
              icon='labeled'
              inverted
              onHide={() => setVisible(false)}

              visible={visible}
              width='thin'

            >

              <Menu.Item as='a' onClick={() => changegView({ myView: "AddTournament" })} >
                <Icon name='add' />
                {t("menu.dodaj_turniej")}
              </Menu.Item>
              <Menu.Item as='a' onClick={() => changegView({ myView: "MyTournaments" })} >
                <Icon name='winner' />
                {t("menu.moje_turnieje")}
              </Menu.Item>
              <Menu.Item as='a' onClick={() => changegView({ myView: "Members" })} >
                <Icon name='users' />
                {t("menu.uczestnicy")}
              </Menu.Item>

              <Menu.Item as='a' onClick={() => changegView({ myView: "MyAccount" })} >
                <Icon name='user' />
                {t("menu.moje_konto")}
              </Menu.Item>


              {/*
              <Menu.Item as='a' onClick={() => changegView({ myView: "Duel1vs1" })} >
                <Icon name='handshake' />
                {t("menu.1vs1")}
              </Menu.Item>
        
              <Menu.Item as='a' onClick={() => clickLink("/osiagniecia/2")} >
                <Icon name='heart' />
                {t("menu.osiagniecia")}
              </Menu.Item>
              */}

              <Menu.Item as='a' onClick={() => changegView({ myView: "CalendarMatches" })} >
                <Icon name='calendar alternate' />
                {"Kalendarz"}
              </Menu.Item>


              <Menu.Item as='a' onClick={() => clickLink("/faq")} >
                <Icon name='question circle' />
                FAQ
              </Menu.Item>

              <Menu.Item as='a' onClick={() => clickLink("/kontakt")} >
                <Icon name='envelope' />
                {t("menu.kontakt")}
              </Menu.Item>
              <Menu.Item as='a' onClick={() => changegView({ myView: "ShareTournamentToUsers" })} >
                <Icon name='share' />
                {t("menu.udostepnij_turniej")}
              </Menu.Item>

              <Menu.Item as='a' onClick={() => logoutApp()}>
                <Icon name='sign-out' />
                {t("menu.wyloguj")}
              </Menu.Item>


            </Sidebar>

            <Sidebar.Pusher dimmed={visible} id="root-id" style={{ height: '100%' }} >

              {authContext.liveIcon === 1 ? <div >{LiveIcon3(t("LiveText"))}</div> : ''}
              <article id="article-id" style={{ minHeight: height - 40, position: "relative", paddingTop: isDuel() ? 0 : 16, paddingBottom: isDuel() ? 0 : 20 }} className="bgTGColor">



                <RouterPage minHeightH={height} />



              </article>


            </Sidebar.Pusher>
          </Sidebar.Pushable>
          {authContext && authContext.showLoading ? showLoadingRootPage() : ""}
        </>

      }
      {iFrameTG() || isViewTv() ? "" : <ScrollToTop />}

    </>
  )
}

export default MenuPage;